export const ApiErrorMapping = {
  EntityAlreadyExists: _TL_('This profile is already connected to your account.'),
  ExceedTheLimit: _TL_("You've reached the maximum number of social profiles you can connect to your account."),
  InternalError: _TL_('An unidentified error has occurred. Please try again later.'),
  GeneralError: _TL_("We've encountered an error and could not finish this task. Please try again or contact support."),
};

export const generalError = ApiErrorMapping.GeneralError;
